<template>
  <v-card class="text-xs-left">
    <v-img
      v-if="showImage"
      :src="imageURL"
      aspect-ratio="1.75"
      class="gt-img-bg"
    >
      <v-layout column fluid class="text-xs-left">
        <v-flex>
          <v-btn text icon dark @click="onView">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-img>
    <v-card-title primary-title style="position: relative">
      <uppload-btn @uploadComplete="onUploadComplete" v-if="false">
        <template slot-scope="{ on }">
          <v-btn absolute color="pink" top right small fab dark @click="on">
            <v-icon>mdi-upload</v-icon>
          </v-btn>
        </template>
      </uppload-btn>

      <h3 class="headline mb-0 text-truncate">
        <v-chip>
          <v-icon left>mdi-web</v-icon>
          {{ languageCode }}
        </v-chip>
        {{ title }}
      </h3>
    </v-card-title>
    <v-card-text class="py-0">
      <div v-html="description" class="gt-content-list-item-desc"></div>
      <v-row>
        <v-col cols="12">
          <v-chip
            v-if="isDefault"
            key="is_default"
            small
            color="teal"
            outlined
            class="mr-1 mt-1"
            >Default</v-chip
          >
          <v-chip
            v-if="sequence"
            :key="sequence"
            small
            color="teal"
            outlined
            class="mr-1 mt-1"
            >Sequence: {{ sequence }}</v-chip
          >
          <v-chip
            v-for="flag in flags"
            :key="flag"
            small
            color="primary"
            outlined
            class="mr-1 mt-1"
            >{{ flag }}</v-chip
          >
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="grey lighten-4">
      <v-btn text color="teal" @click="onEdit" :disabled="viewOnly">Edit</v-btn>
      <v-btn text color="red" @click="onDelete" :disabled="viewOnly"
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import Uppload from "uppload";
import UpploadBtn from "./UpploadBtn";
import { getVisibilityOptionsFromContent } from "./visibility-options";
export default {
  name: "content-item",
  props: {
    value: {
      type: Object,
    },
    showImage: {
      type: Boolean,
      default: () => true,
    },
    viewOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    UpploadBtn,
  },
  data() {
    return {
      image: this.value && this.value.imgURL ? this.value.imgURL : "",
    };
  },
  computed: {
    flags() {
      return getVisibilityOptionsFromContent(this.value);
    },
    sequence() {
      //https://tracker.globetrack.ie/issues/6332
      return this.value ? this.value.sequence : false;
    },
    isDefault() {
      //https://tracker.globetrack.ie/issues/6332
      return this.value ? this.value.isDefault : false;
    },
    imageURL() {
      return this.image != "" &&
        this.image != "null" &&
        this.image.indexOf("brokenImageSkin") == -1
        ? this.image
        : "https://via.placeholder.com/600x400.png?text=Content%20Image";
    },
    languageCode() {
      return this.value.language ? this.value.language.code : "EN";
    },
    description() {
      return this.value
        ? this.value.description
        : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin nibh augue, suscipit a, scelerisque sed, lacinia in, mi. Cras vel lorem. Etiam pellentesque aliquet tellus. Phasellus pharetra nulla ac diam. Quisque semper justo at risus...";
    },
    title() {
      return this.value ? this.value.name : "Content Title";
    },
  },
  methods: {
    onUploadComplete(payload) {
      if (payload.success) {
        this.image = payload.fileURL;
      }
    },
    onView(event) {
      this.$emit("onViewImage", this.image);
    },
    onEdit(event) {
      this.$emit("onEdit", this.value);
    },
    onDelete(event) {
      this.$emit("onDelete", this.value);
    },
  },
  watch: {
    value(newVal) {
      this.image = newVal.imgURL;
    },
  },
};
</script>

<style>
.uppload-modal {
  font-family: sans-serif;
}
.gt-img-bg {
  background-color: #3367d6;
  background: linear-gradient(#0fbfff, #3367d6);
}
.gt-content-list-item-desc {
  height: 150px;
  overflow: scroll;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/contents/ContentItem.vue